export const JSON_ARRAY = 'json_array';
export const JSON_OBJECT = 'json_object';
export const SQL_ARRAY = 'sql_array';
